
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['../constants'], function(constants) {
	'use strict';
	class Rave2bundlewaterfall {
		get config(){
			return {
				'type':'Waterfall',
				'isRecommendable': false,
				'ignoreElementColor': true,
				'doesNotSupportCategoricalPalette': true,
				'thumbnail': {
					'properties': {
						'valueAxis.gridLines.visible': true
					}
				},
				'listenForPropChanges':[
					'widget.legend.size'
				],
				'propertiesToSetBeforeData': [
					'widget.data.truncate'
				],
				'aggregateAndSortOnClient':true,
				'slots':{
					'categories':{
						'sort':'asc',
						'icon':'x-axis_bars',
						'tags': ['badge'],
						'mldTitleProperty': 'itemAxis.title'
					},
					'subcategories':{
						'tags': ['ca.dashboard.repeatHere=true' ]
					},
					'values':{
						'weightedRepeats':true,
						'sortable':true,
						'multiMeasure':true,
						'clientSideAggregatedAndSortInfo':{
							'mappedSlotCondition':[
								'color'
							],
							'groupOnColumnId':'categories'
						},
						'icon':'values',
						'tags': ['badge'],
						'mldTitleProperty': 'valueAxis.title'
					},
					'repeatHorizontal':{
						'icon':'multiplier_h',
						'sort':'asc'
					},
					'repeatVertical':{
						'icon':'multiplier_v',
						'sort':'asc'
					}
				},
				'entryDurationProperty': 'effect.entry.bar.duration',
				'propertyPrefixes': {
					'dataPoint': 'itemAxis.ticks.labels',
					'values': 'valueAxis.title',
					'categories': 'itemAxis.title',
					'color': 'widget.legend',
					'legend':'widget.legend',
					'row': 'widget.repeatVertical.labels',
					'column': 'widget.repeatHorizontal.labels'
				},
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont'],
					'itemAxis.ticks.labels.color': ['valueAxis.ticks.labels.color','valueLabels.color'],
					'itemAxis.ticks.labels.font': ['valueAxis.ticks.labels.font','valueLabels.font']
				},
				'elementStyle': {
					'groupedAxes': [
						['itemAxis.ticks.labels','valueAxis.ticks.labels'],
						['itemAxis.title','valueAxis.title']
					]
				},
				'properties':{
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'itemAxis.title': {
						'multilingual': true
					},
					'valueAxis.title': {
						'multilingual': true
					},
					'bar.direction.vertical':{
						'defaultValue':true,
						'active':false,
						'isReadOnly': true
					},
					'stacked':{
						'defaultValue':false,
						'active':false,
						'isReadOnly': true
					},
					'format.compact':{
						'active':false
					},
					'valueAxis.zeroOrigin':{
						'defaultValue':true
					},
					'effect.duration': {
						'defaultValue': constants.SHORT_EFFECT_DURATION,
						'active': false
					},
					'effect.entry.bar.type': {
						'public': false
					},
					'effect.entry.bar.delay': {
						'active': false,
						'defaultValue': 0
					},
					'effect.entry.bar.stagger': {
						'public': false
					},
					'effect.entry.bar.duration':{
						'displayMultiplier': 0.001,
						'public': false,
						'defaultValue': constants.SHORT_EFFECT_DURATION
					},
					'values.null.color':{
						'active': false
					},
					'column.border.width':{
						'active': false
					},
					'column.border.color':{
						'active': false
					},
					'totalColumn.positive.color':{
						'addButton': true,
						'colorClass': true
					},
					'totalColumn.negative.color':{
						'addButton': true,
						'colorClass': true
					},
					'firstColumn.positive.color':{
						'predefinedValue': 'null', // initially deactive
						'addButton': true,
						'colorClass': true
					},
					'firstColumn.negative.color':{
						'predefinedValue': 'null', // initially deactive
						'addButton': true,
						'colorClass': true
					},
					'column.positive.color':{
						'addButton': true,
						'colorClass': true
					},
					'column.negative.color':{
						'addButton': true,
						'colorClass': true
					},
					'widget.legend.size': {
						'active': false
					},
					'itemAxis.title.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'valueAxis.title.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'itemAxis.ticks.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'valueAxis.ticks.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'valueAxis.minValue': constants.minMaxValidationOptions,
					'valueAxis.maxValue': constants.minMaxValidationOptions,
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					},
					'totalColumn.label': {
						'multilingual': true
					},
					'valueAxis.gridLines.color':{
						'colorClass': true,
						'addButton': true
					},
					'itemAxis.line.color':{
						'colorClass': true,
						'addButton': true
					},
					'valueAxis.line.color':{
						'colorClass': true,
						'addButton': true
					},
					'itemAxis.ticks.labels.rotateAngle': {
						'percentage': false
					},
					'widget.repeatHorizontal.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.repeatVertical.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					}
				},
				'queryHints':{
					'multiEdgeSort':true
				},
				config:{
					'include':[
						'backgroundColor',
						'widget.legend.backgroundColor',
						'optimizeSize',
						'widget.data.truncate',
						'widget.iterator',
						'itemAxis.title.visible',
						'itemAxis.ticks.labels.visible',
						'itemAxis.ticks.visible',
						'itemAxis.labels.layoutMode',
						'itemAxis.ticks.labels.font',
						'itemAxis.ticks.color',
						'itemAxis.ticks.labels.color',
						'itemAxis.line.visible',
						'itemAxis.gridLines.visible',
						'itemAxis.title',
						'itemAxis.title.font',
						'itemAxis.title.color',
						'valueAxis.title.visible',
						'valueAxis.ticks.labels.visible',
						'valueAxis.ticks.visible',
						'valueAxis.ticks.color',
						'valueAxis.line.visible',
						'valueAxis.gridLines.visible',
						'valueAxis.zeroOrigin',
						'valueAxis.title',
						'valueAxis.title.font',
						'valueAxis.title.color',
						'valueAxis.ticks.labels.font',
						'valueAxis.minValue',
						'valueAxis.maxValue',
						'valueAxis.ticks.labels.color',
						'valueLabels.visible',
						'valueLabels.location',
						'valueLabels.orientation',
						'totalColumn.visible',
						'totalColumn.label',
						'column.border.width',
						'column.border.color',
						'transpose',
						'effect.duration',
						'widget.legend.display',
						'widget.legend.position',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.font',
						'widget.legend.titleFont',
						'widget.legend.titleColor',
						'widget.legend.swatch.symbol.default',
						'widget.repeatHorizontal.labels.color',
						'widget.repeatVertical.labels.color',
						'widget.repeatHorizontal.labels.font',
						'widget.repeatVertical.labels.font',
						'totalColumn.legend.label.positive',
						'totalColumn.legend.label.negative',
						'firstColumn.positive.label',
						'firstColumn.negative.label',
						'value.positive.label',
						'value.negative.label',
						'totalColumn.positive.color',
						'totalColumn.negative.color',
						'firstColumn.positive.color',
						'firstColumn.negative.color',
						'column.positive.color',
						'column.negative.color',
						'widget.legend.size',
						'widget.legend.titleVisible',
						'valueAxis.tickInterval',
						'subcategory.totals',
						'subcategory.values',
						'itemAxis.line.color',
						'valueAxis.line.color',
						'itemAxis.line.visible',
						'valueAxis.line.visible',
						'itemAxis.ticks.labels.rotateAngle',
						'valueLabels.font',
						'valueLabels.color',
						'contrast.label.color',
						'label.shadow'
					],
					'exclude':[
					]
				},
				'usages':[
					'Trend'
				],
				'supportsMaintainAxisScale': false
			};
		}
	}
	return Rave2bundlewaterfall;
});
